import React from 'react';
import { Spinner } from '@chakra-ui/react';
import { HStack, Heading } from 'components/ui';

export const LoaderDefaultProps = {
  size: 'sm',
  label: 'Loading',
  color: 'secondary.500',
  headingColor: 'secondary.500',
  fontSize: 'sm',
  loading: false,
  p: 5,
};

export const Loader = (props) => {
  const merged = { ...LoaderDefaultProps, ...props };

  return (
    <HStack gap={2} p={merged.p} my={props.my} justifyContent="center">
      <Spinner
        aria-label={merged.label}
        size={merged.size}
        color={merged.color}
      />

      {!props.noText && (
        <Heading color={merged.headingColor} fontSize={merged.fontSize}>
          {merged.label}
        </Heading>
      )}
    </HStack>
  );
};
